import { Area } from "../models/Area";

export interface AreaProgress {
  ratedCount: number;
  totalCount: number;
  percent: number;
  complete: boolean;
}

export const computeAreaProgress = (area: Area, ratings: Record<string, number>): AreaProgress => {
  const subAreas = area.subArea ?? [];
  const detailKeys = subAreas.flatMap(sa =>
    (sa.subAreaDetails ?? []).map(d => `${sa.subAreaId}-${d.subAreaDetailId}`)
  );
  const ratedCount = detailKeys.filter(
    k => typeof ratings[k] === "number" && ratings[k] !== -1
  ).length;
  const totalCount = detailKeys.length;
  const percent = totalCount === 0 ? 0 : Math.round((ratedCount / totalCount) * 100);
  const complete = totalCount > 0 && ratedCount === totalCount;
  return { ratedCount, totalCount, percent, complete };
};

export const isAreaComplete = (area: Area, ratings: Record<string, number>) =>
  computeAreaProgress(area, ratings).complete;